import { Dialog } from '@headlessui/react';
import EventLabel from '../../components/EventLabel/EventLabel';
import { useEffect, useMemo, useState } from 'react';

export function AddToHomeScreen() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [hide, setHide] = useState(false);

  const userAgent = navigator.userAgent.toLowerCase();

  let isChrome = /chrome/.test(userAgent);
  let isSafari = /safari/.test(userAgent);

  const isOpera = /opr/.test(userAgent);
  const isEdgeDesktop = /edge/.test(userAgent);
  const isEdgeiOS = /edgios/.test(userAgent);
  const isEdgeAndroid = /edga/.test(userAgent);
  const isIOS = /ipad|iphone|ipod/.test(userAgent);
  const isMobile = /mobile/.test(userAgent);

  if (isChrome && isSafari) {
    isSafari = false;
  }
  if (isChrome && (isEdgeDesktop || isEdgeiOS || isEdgeAndroid)) {
    isChrome = false;
  }
  if (isSafari && (isEdgeDesktop || isEdgeiOS || isEdgeAndroid)) {
    isSafari = false;
  }
  if (isChrome && isOpera) {
    isChrome = false;
  }

  // Check if the app is already added to the home screen
  const isAddedToHomeScreen = !!window.matchMedia('(display-mode: standalone)').matches;

  // useEffect(() => {
  //   window.addEventListener('beforeinstallprompt', e => {
  //     // show your custom button

  //     // Prevent Chrome 67 and earlier from automatically showing the prompt
  //     // no matter what, the snack-bar shows in 68 (beta 06/16/2018 11:05 AM)
  //     e.preventDefault();

  //     // Save the prompt so it can be displayed when the user wants
  //     setDeferredPrompt(e);
  //   });

  //   window.addEventListener('appinstalled', evt => {
  //     setHide(true);
  //     // if installed, hide your custom button?
  //     // if installed, call Google Analytics to track?
  //   });
  // }, []);

  // if (isAddedToHomeScreen || !isMobile) {
  //   return null;
  // }

  const content = useMemo(() => {
    if (isIOS || isSafari) {
      return <img src="https://www.contaware.com/images/stories/ContaCam/iphone-addtohomescreen.png" className="max-w-full" alt="Add to home screen" />;
    } else if (isChrome && !isIOS) {
      return (
        <img
          src="https://www.lambdatest.com/resources/images/software-testing-questions/add-to-home-screen.png"
          className="max-w-full max-h-96"
          alt="Add to home screen"
        />
      );
    }

    return null;
  }, [isIOS, isChrome]);

  return (
    <>
      <Dialog open={!isAddedToHomeScreen} onClose={() => {}} className="relative z-50">
        <div className="fixed inset-0 bg-black/80" aria-hidden="true" />
        <div className="fixed inset-0 flex w-screen items-center justify-center p-4">
          <Dialog.Panel className="border border-zinc-200 rounded-md bg-white p-6">
            <div className="font-bold text-lg mb-1">
              <EventLabel name="AddToHomeScreenRequired" groupName="Cms.AddToHomeScreen" />
            </div>
            <Dialog.Description className="text-sm mb-6">
              <EventLabel name="AddToHomeScreenInstructions" groupName="Cms.AddToHomeScreen" />
            </Dialog.Description>
            {content}
          </Dialog.Panel>
        </div>
      </Dialog>
    </>
  );
}
